module.exports = __webpack_public_path__ + "static/media/Mohammed Arshad .38eabaff.jpeg";